module.exports = __webpack_public_path__ + "static/img/汽配嘉年华.aed0356a.png";